import { useState } from "react";
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.min.css";

import Role from "./login/Role.js";
// employee side
import Login from "./login/Login.js";
import Password from "./login/Password.js";
import FirstLoginPassword from "./login/FirstLoginPassword.js";
import ForgotPassword from "./login/ForgotPassword.js"
import ResetPassword from "./login/ResetPassword.js";
import Dashboard from "./dashboard/Dashboard.js";
import ProfileNav from "./profile/ProfileNav.js";
import ProfileSetting from "./profile/ProfileSetting.js";
import ChangePassword from "./profile/ChangePassword.js";
import DashboardNav from "./dashboard/DashboardNav.js";
import GeneralTraining from "./dashboard/GeneralTraining.js";
import PositionalTraining from "./dashboard/PositionalTraining.js";
import Notification from "./dashboard/Notification.js";
// import Quiz from "./dashboard/Quiz.js";
import QuizMain from "./quiz/QuizMain.js";
import QuizIntro from "./quiz/QuizIntro.js";
import Quiz from "./quiz/Quiz.js";
import Result from "./quiz/Result.js";
import EmployeeFeedbackView from "./quiz/EmployeeFeedbackView.js";
import PreJobPreparation from "./dashboard/PreJobPreparation.js";

// manager side
import Layout from "./manager-dashboard/Layout.js";
import ManagerDashboard from "./manager-dashboard/ManagerDashboard.js";
// import ManagerDashboardNav from "./manager-dashboard/ManagerDashboardNav.js";
import ManagerProfileNav from "./manager-dashboard/ManagerProfileNav.js";
import ManagerProfileNavData from "./manager-dashboard/ManagerProfileNavData.js";
// import ManagerNotification from "./manager-dashboard/ManagerNotification.js";
// Manager feedback
import ManagerFeedbackList from "./manager-feedback/ManagerFeedbackList.js";
import ManagerFeedbackQuizList from "./manager-feedback/ManagerFeedbackQuizList.js";
import ManagerFeedbackForm from "./manager-feedback/ManagerFeedbackForm.js";
// lesson
import LessonUpload from "./manager-dashboard/LessonUpload.js";
import LessonAssign from "./manager-dashboard/LessonAssign.js";
import LessonLibrary from "./manager-dashboard/LessonLibrary.js";
import AssignPosition from "./manager-dashboard/AssignPosition.js";
// ID management
import CreateID from "./manager-dashboard/CreateID.js";
import DeleteID from "./manager-dashboard/DeleteID.js";

const App = props => {
    return (<>
        <ToastContainer />
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Role />} />
                {/* <Route path="/login" element={<Navigate to="/login" />} /> */}
                <Route path="/login" element={<Login />} />
                <Route path="/password" element={<Password />} />
                <Route path="/first-login" element={<FirstLoginPassword />} />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path="/resetPassword" element={<ResetPassword />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<ProfileNav />} />
                <Route path="/profile/setting" element={
                    <ProfileSetting
                        backLink="/dashboard"
                        details={[
                            "Direct Manager: Naoyu",
                            "Current Store: Hasting St. Vancouver",
                            "Start Date: April 2nd, 2026",
                        ]}
                    />
                } />
                <Route path="/profile/change-password" element={
                    <ChangePassword
                        backLink="/dashboard"
                    />}
                />
                <Route path="/dashboard/dashboard-nav" element={<DashboardNav />} />
                <Route path="/dashboard/notification" element={<Notification />} />
                <Route path="/dashboard/general-training" element={<GeneralTraining />} />
                <Route path="/dashboard/general-training/pre-job-preparation" element={<PreJobPreparation />} />
                <Route path="/dashboard/positional-training" element={<PositionalTraining />} />
                {/* <Route path="/dashboard/quiz" element={<Quiz />} /> */}
                <Route path="/quiz/main" element={<QuizMain />} />
                <Route path="/quiz/:id/intro" element={<QuizIntro />} />
                <Route path="/quiz/:id" element={<Quiz />} />
                <Route path="/quiz/:id/:employeeId/result" element={<Result />} />
                <Route path="/quiz/:id/feedback" element={<EmployeeFeedbackView />} /> 

                {/* manager side */}
                <Route element={<Layout />}>
                    {/* マネージャー関連のRoute全部ここに */}
                    <Route path="/manager/dashboard" element={<ManagerDashboard />} />
                    {/* <Route path="/manager-dashboard/manager-notification" element={<ManagerNotification />} /> */}
                    <Route path="/manager/profile" element={
                        <ProfileSetting
                            backLink="/manager/dashboard"
                            details={[
                                "Direct Manager: Brit Patt",
                                "Store: Hasting St. Vancouver",
                                "Start Date: December 2nd, 2025",
                            ]}
                            showHeader={false}
                            showBackLink={false}
                            className="manager-prof-setting-content"
                        />
                    } />
                    <Route path="/manager/profile/setting" element={
                        <ProfileSetting
                            backLink="/manager/dashboard"
                            details={[
                                "Direct Manager: Brit Patt",
                                "Store: Hasting St. Vancouver",
                                "Start Date: December 2nd, 2025",
                            ]}
                            showHeader={false}
                            showBackLink={false}
                            className="manager-prof-setting-content"
                        />
                    } />
                    <Route path="/manager/profile/setting" element={<ManagerProfileNavData />} />
                    <Route path="/manager/profile/change-password" element={
                        <ChangePassword
                            backLink="/manager/dashboard"
                            showHeader={false}

                            className="manager-pw-change"
                        />}
                    />
                    <Route path="/manager/feedback-employee-list" element={<ManagerFeedbackList />} />
                    <Route path="/manager/feedback/:employeeId/quizzes" element={<ManagerFeedbackQuizList />} />
                    <Route path="/manager/feedback/:employeeId/:quizId/form" element={<ManagerFeedbackForm />} />
                    
                    <Route path="/manager/dashboard/lessons/upload" element={<LessonUpload />} />
                    <Route path="/manager/dashboard/lessons/assign" element={<LessonAssign />} />
                    <Route path="/manager/dashboard/lessons/assign/positions" element={<AssignPosition />} />
                    <Route path="/manager/dashboard/lessons/library" element={<LessonLibrary />} />
                    <Route path="/manager/dashboard/empID-create" element={<CreateID />} />
                    <Route path="/manager/dashboard/empID-delete" element={<DeleteID />} />
                </Route>
            </Routes>
        </BrowserRouter>
    </>
    );
}

export default App;